import { Filter, FilterObject } from '@interface';
import { userRoutes } from '@services';
import { AppString } from '@utils';
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

// Create an axios instance
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add an interceptor to automatically attach the token to each request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(AppString.user_token); // Get token dynamically
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Optimized API functions
export const addPropertyBookMarked = async (userData: {
    bbl: string;
    name: string;
    borough: string;
    postalcode: string;
}) => {
    try {
        return await api.post(userRoutes.ADD_PROPERTY_BOOKMARK, userData);
    } catch (error) {
        console.error("Error adding bookmark:", error);
        throw error;
    }
};

export const removePropertyBookMarked = async (bbl: string) => {
    try {
        return await api.delete(`${userRoutes.REMOVE_PROPERTY_BOOKMARK}?bbl=${bbl}`);
    } catch (error) {
        console.error("Error removing bookmark:", error);
        throw error;
    }
};

export const getListPropertyBookMarked = async (bbl: string | undefined = '') => {
    try {
        return await api.get(`${userRoutes.GET_PROPERTY_BOOKMARK}?bbl=${bbl}`);
    } catch (error) {
        console.error("Error fetching bookmarks:", error);
        throw error;
    }
};

export const addSaveSearch = async (searchData: {
    name: string;
    housingType?: string;
    housingFilters?: Filter[];
    addFilters?: FilterObject[];
    logicalOperator?: "AND" | "OR";
    navigateParam: string;
}) => {
    try {
        return await api.post(userRoutes.ADD_CUSTOM_BOOKMARK, searchData);
    } catch (error) {
        console.error("Error adding bookmark:", error);
        throw error;
    }
};

export const removeSaveSearch = async (customSearchId: string) => {
    try {
        return await api.delete(`${userRoutes.REMOVE_CUSTOM_BOOKMARK}?customSearchId=${customSearchId}`);
    } catch (error) {
        console.error("Error removing bookmark:", error);
        throw error;
    }
};

export const getListSavedSearch = async (navigateParam: string | undefined = '') => {
    try {
        return await api.get(`${userRoutes.GET_CUSTOM_BOOKMARK}?navigateParam=${navigateParam}`);
    } catch (error) {
        console.error("Error fetching bookmarks:", error);
        throw error;
    }
};

export const editSavedSearch = async (searchData: Record<string, any>) => {
    try {
        return await api.put(`${userRoutes.EDIT_CUSTOM_BOOKMARK}`, searchData);
    } catch (error) {
        console.error("Error fetching bookmarks:", error);
        throw error;
    }
};